import { GRAY } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    GRAY_100_DIV,
} from '@/styles/common.styled.component';
import styled from 'vue-styled-components';

export const ListWrapper = styled.ul`
    width: 100%;
    display: flex;

    background-color: white;
    flex-direction: column;
`;

export const BasicOptionsWrapper = styled(FLEX_COLUMN_DIV)`
    padding: 12px 16px;
`;

export const BasicOptionsMetricWrappert = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 25px;
`;

export const BasicOptionTitle = styled(GRAY_100_DIV)`
    margin-bottom: 17px;
`;

export const ItemWrapper = styled.li`
    display: flex;
    gap: 12px;
`;

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    .info-line-icon {
        width: 24px;
        height: 24px;
    }
`;

export const AdvancedWrapper = styled.div`
    padding: 12px 16px;
    border-top: 1px solid #d9d9d9;
`;

export const AdvancedItemWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 10px;

    & .advanced-filter-option-metric-box {
        width: 220px;
        & .selected-box {
            background: ${GRAY(10)};
        }
    }

    & .advanced-filter-option-operator-box {
        width: 56px;
        &.disabled .selected-box {
            background: ${GRAY(10)};
        }
    }

    & .advanced-filter-option-input {
        & input {
            max-width: 140px;
            &:disabled {
                background: ${GRAY(10)};
                cursor: not-allowed;
            }
        }
    }
`;

export const OperatorWarpper = styled(FLEX_VERTICAL_CENTER_DIV)``;
